/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import composerNodeUrl from "url:../assets/images/composer_node.png";

export const composerNodesContent = `
## Summary

Composer nodes are a means to customize the final transformed data in your pipeline. Once processing is complete, you can download the results from these nodes.

These nodes can only take in inputs from transform nodes.  It's not possible to connect an input node to a composer node without an intermediary transform node.

### Anatomy

<img src="${composerNodeUrl}" alt="Composer Node" style="max-width: 600px; height: auto; display: block; margin: 24px auto;" />

- **1** - Node data type indicator
- **2** - Node title
- **3** - Node title edit button
- **4** - Button to display file view
- **5** - Drag handle to reorder fields
- **6** - Connector handle for connecting to transform nodes
- **7** - Download button

### Adding Composer Nodes

Click the composer node button in the control bar to add a new composer node. The node will be automatically positioned based on existing transforms.

### Downloading Outputs

Individual outputs can be downloaded by clicking the download button on the composer node.

### Previewing Outputs

Composer node outputs can be previewed in the application by clicking the file view button on the composer node.

### Customizing Composer Node Outputs

A single composer node can take in data from several different transform nodes, provided that all of the transformed data is of the same type, for example, XML.

In other words, several **PX** transform nodes can be connected to the same output node, since all of this data will be of type XML.

Unlike standard output nodes, composer nodes allow customization of the order and composition of data by dragging and dropping individual fields to reorder them.

This is subject to some restrictions including, but not limited to:
- Certain structures like Protobuf enums and oneOfs cannot be modified
- Certain structures like Protobuf services cannot be nested
- Certain structures like Protobuf messages must contain at least one data field

If an operation is performed that is not permitted, the UI will not perform the modification and a toast message will appear explaining the problem.

### Output File Names

By default, composer nodes use the name of the input file with a suffix. This can be customized by clicking and renaming the title of the composer node.

### Managing Outputs

- Multiple composer nodes can be created in a single transform.
- Composer node content will update when connected to different transform nodes.
- Composer node field ordering is retained when mappings are saved and re-loaded.
`;
